import { render, staticRenderFns } from "./SyncPanelHeaderButton.vue?vue&type=template&id=82b362fc&"
import script from "./SyncPanelHeaderButton.vue?vue&type=script&lang=ts&"
export * from "./SyncPanelHeaderButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports